import { defineStore } from 'pinia'

export const useAuthStore = defineStore('auth', {
    state: () => ({
        authenticated: false,
        email: '',
        password: '',
        firstname: '',
        lastname: '',
        iduser: '',
        permissions: [],
    }),

    actions: {
        setAuthenticated(authenticated, email, password, userdata) {
            this.authenticated = authenticated
            this.email = email
            this.password = password
            this.firstname = userdata.firstname
            this.lastname = userdata.lastname
            this.iduser = userdata.iduser
            this.permissions = userdata.permissions
        },

        isAuthenticated() {
            return this.authenticated
        },

        loadFromLocalStorage() {
            const saved = localStorage.getItem('auth')
            if (saved) {
                try {
                    this.$patch(JSON.parse(saved))
                } catch (e) {
                    console.warn('Could not parse auth from localStorage:', e)
                }
            }
        }
    }
})
